export const supportedLivescores = ['football', 'tennis', 'basketball'];
export const noScoreboards = ['horse-racing', 'greyhounds'];
